import VideoFileEditor from '@intercom/embercom-composer/components/video-file-editor';
export default VideoFileEditor;
